import React from 'react'
// import Link
import { Link } from 'react-router-dom'
// import Sidebar
import SideBar from './SideBar'
// Import BigImg
import BigImg from "../../assets/img/causes/details-big.png"
import causesImg from "../../assets/img/causes/details-small-1.png"
import causesImg1 from "../../assets/img/causes/details-small-2.png"
import PdfIcon from "../../assets/img/icon/pdf.png"
import PostImg from "../../assets/img/common/post-1.png"
import PostImg1 from "../../assets/img/common/post-2.png"

const CausesDetailsArea = () => {

  return (
    <>
          <section id="trending_causes_main" class="section_padding">
        <div class="container">
            <div class="row" id="counter">
                <div class="col-lg-8">
                    <div class="details_wrapper_area">
                        <div class="details_big_img">
                            <img src={BigImg} alt="img" />
                            <span class="causes_badge bg-yellow">Education &amp; integration</span>
                        </div>
                        <div class="details_text_wrapper">
                            <h2>Homework help, learning circles &amp; integration support</h2>
                            <p>
                                PCF learning circles give children a calm space to finish homework, practise Swedish, and stay
                                connected to Urdu and culture. Alongside study time we weave in <strong>integration</strong> topics: how
                                school works in Sweden, how to read letters from förskola or “kommun”, and where to ask for help.
                            </p>
                            <p>
                                Volunteer tutors and parents collaborate—many have walked the same path of settling in Sweden.
                                Families new to the country get paired where we can with a buddy parent for casual questions
                                outside session hours.
                            </p>
                            <h3>What families gain</h3>
                            <p>
                                Children build reading and maths confidence; parents build confidence in the system. We often
                                combine a study Saturday with a short <strong>social</strong> tea—so homework support and community
                                friendships grow together. Our main sport remains <strong>badminton</strong>; seasonal swim, cricket, and
                                football are advertised separately.
                            </p>
                            <ul>
                                <li><i class="fas fa-circle"></i> Structured homework and Swedish practice.</li>
                                <li><i class="fas fa-circle"></i> Urdu, storytelling, and cultural literacy.</li>
                                <li><i class="fas fa-circle"></i> Integration Q&amp;A slots for adults (rotating topics).</li>
                                <li><i class="fas fa-circle"></i> Signposting to school meetings, health, and local activities.</li>
                            </ul>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="details_small_img">
                                        <img src={causesImg} alt="img" />
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div class="details_small_img">
                                        <img src={causesImg1} alt="img" />
                                    </div>
                                </div>
                            </div>
                            <p>
                                To register your child or offer tutoring help, contact info@pcfsweden.se with the child’s
                                school year and your city. We will reply with the next start date and venue.
                            </p>
                        </div>
                        <div class="download_pdf_area">
                            <div class="pdf_download_left">
                                <img src={PdfIcon} alt="icon" />
                                <h4>Parent info — study &amp; integration (PDF)</h4>
                            </div>
                            <div class="pdf_download_right">
                                <Link to="#!" class="btn btn_md btn_theme">Download now</Link>
                            </div>
                        </div>
                        <div class="comment_area_details">
                            <h3>Community notes</h3>
                            <div class="post_comment_wrapper">
                                <div class="post_comment_item">
                                    <div class="post_comment_img">
                                        <img src={PostImg} alt="img" />
                                    </div>
                                    <div class="post_comment_text">
                                        <div class="post_names_replay">
                                            <h5>Sara K.</h5>
                                            <a href="#!"><i class="fas fa-reply"></i>Reply</a>
                                        </div>
                                        <p>My daughter feels more confident asking questions here than in a big classroom.
                                            Thank you to all tutors.</p>
                                    </div>
                                </div>
                                <div class="post_comment_item">
                                    <div class="post_comment_img">
                                        <img src={PostImg1} alt="img" />
                                    </div>
                                    <div class="post_comment_text">
                                        <div class="post_names_replay">
                                            <h5>Yusuf R.</h5>
                                            <a href="#!"><i class="fas fa-reply"></i>Reply</a>
                                        </div>
                                        <p>We joined mid-term and were welcomed straight away. The schedule works well after
                                            school.</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="comment_form_area">
                            <h3>Leave a comment</h3>
                            <div class="comment_form">
                                <form action="#!" id="comment_form">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="Enter full name"
                                                    required />
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <input type="text" class="form-control"
                                                    placeholder="Enter email address" required />
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="form-group">
                                                <textarea rows="5" placeholder="Write your comments"
                                                    class="form-control" required></textarea>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="submit_btn">
                                                <button class="btn btn_theme btn_md">Submit comment</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
               <SideBar/>
            </div>
        </div>
    </section>
    </>
  )
}

export default CausesDetailsArea